export function SVG_AddPair(base, x, y) {
  return base + x + "," + y + " ";
}
